// Module: apps — «التطبيقات» (HANDOFF §3 / §5.9, board 14 part 3). Menu:
// المتجر · المثبّتة · الفوترة · تطبيقاتي. Flag erp.store; owner and manager
// only (staff never sees the rail entry — board expired--license tile B).
// Owner-only routes: install from file, app settings, billing. The server
// enforces every one of them again.

import { Blocks } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { defineModule, gate } from '@/app/module-types';

export default defineModule({
  key: 'apps',
  label: 'التطبيقات',
  icon: Blocks,
  flag: 'erp.store',
  minRole: 'manager',
  rail: 'apps',
  routes: [
    { path: '/apps', element: <Navigate to="/apps/store" replace /> },
    { path: '/apps/store', lazy: () => import('./screens/StoreHome').then((m) => ({ Component: m.StoreHome })) },
    { path: '/apps/store/:appId', lazy: () => import('./screens/AppDetail').then((m) => ({ Component: m.AppDetail })) },
    { path: '/apps/install-file', lazy: () => import('./screens/InstallFile').then((m) => ({ Component: m.InstallFile })), handle: gate({ minRole: 'owner' }) },
    { path: '/apps/installed', lazy: () => import('./screens/InstalledList').then((m) => ({ Component: m.InstalledList })) },
    { path: '/apps/installed/:installId', lazy: () => import('./screens/AppSettings').then((m) => ({ Component: m.AppSettings })), handle: gate({ minRole: 'owner' }) },
    { path: '/apps/billing', lazy: () => import('./screens/Billing').then((m) => ({ Component: m.Billing })), handle: gate({ minRole: 'owner' }) },
    { path: '/apps/my', lazy: () => import('./screens/MyApps').then((m) => ({ Component: m.MyApps })) },
    { path: '/apps/my/:installId', lazy: () => import('./screens/MyApps').then((m) => ({ Component: m.MyAppPage })) },
  ],
  menu: [
    { key: 'store', label: 'المتجر', to: '/apps/store' },
    { key: 'installed', label: 'المثبّتة', to: '/apps/installed' },
    { key: 'billing', label: 'الفوترة', to: '/apps/billing', minRole: 'owner' },
    { key: 'my', label: 'تطبيقاتي', to: '/apps/my' },
  ],
});
